<template>
  <div>
    <a-dropdown v-if="currentUser && currentUser.name" placement="bottomRight">
      <span class="ant-pro-account-avatar">
        <a-avatar size="small" :src="avatar" class="antd-pro-global-header-index-avatar" />
        <span>{{ currentUser.name }}</span>
      </span>
      <template v-slot:overlay>
        <a-card style="width: 300px;padding: 20px">
          <p class="item">账号ID：{{ userInfo.userId || '-' }}</p>
          <p class="item">姓名：{{ userInfo.name || '-' }}</p>
          <p class="item">账号：{{ userInfo.phone || '-' }}</p>
          <div class="flex" style="gap: 12px;padding-top: 20px;display:flex;">
            <a-button class="flex1" type="primary" ghost @click="openFeedback">用户反馈</a-button>
            <a-button class="flex1" type="link" @click="modifyPwd">修改密码</a-button>
            <a-button class="flex1" type="danger" ghost @click="handleLogout">登出</a-button>
          </div>
        </a-card>

        <!--      <a-menu class="ant-pro-drop-down menu" :selected-keys="[]">-->
        <!--        <a-menu-item v-if="menu" key="center" @click="handleToCenter">-->
        <!--          <a-icon type="user" />-->
        <!--          {{ $t('menu.account.center') }}-->
        <!--        </a-menu-item>-->
        <!--        <a-menu-item v-if="menu" key="settings" @click="handleToSettings">-->
        <!--          <a-icon type="setting" />-->
        <!--          {{ $t('menu.account.settings') }}-->
        <!--        </a-menu-item>-->
        <!--        <a-menu-divider v-if="menu" />-->
        <!--        <a-menu-item key="logout" @click="handleLogout">-->
        <!--          <a-icon type="logout" />-->
        <!--          {{ $t('menu.account.logout') }}-->
        <!--        </a-menu-item>-->
        <!--      </a-menu>-->
      </template>
    </a-dropdown>
    <span v-else>
      <a-spin size="small" :style="{ marginLeft: 8, marginRight: 8 }" />
    </span>

    <!-- 用户反馈弹窗 -->
    <a-modal
      v-model="feedbackVisible"
      title="用户反馈"
      :confirm-loading="feedbackSubmitting"
      @ok="handleSubmitFeedback"
      @cancel="() => { feedbackVisible = false }"
    >
      <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
        <a-form-item label="类型">
          <a-select v-model="feedbackForm.type" style="width: 160px;">
            <a-select-option value="建议">建议</a-select-option>
            <a-select-option value="问题">问题</a-select-option>
            <a-select-option value="故障">故障</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="内容">
          <a-textarea
            v-model="feedbackForm.content"
            :rows="4"
            :maxlength="500"
            placeholder="请描述您的问题或建议（不少于10个字）"
            show-count
          />
        </a-form-item>
        <a-form-item label="联系方式">
          <a-input v-model="feedbackForm.contact" placeholder="选填：邮箱/手机号/微信" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { Modal } from 'ant-design-vue'
import avatar from '@/assets/avatar.jpg'
import { mapState } from 'vuex'

export default {
  name: 'AvatarDropdown',
  props: {
    currentUser: {
      type: Object,
      default: () => null
    },
    menu: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      avatar,
      feedbackVisible: false,
      feedbackSubmitting: false,
      feedbackForm: {
        type: '建议',
        content: '',
        contact: ''
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.info
    })
  },
  methods: {
    handleToCenter () {
      this.$router.push({ path: '/mediaAccount/center' })
    },
    handleToSettings () {
      this.$router.push({ path: '/mediaAccount/settings' })
    },
    handleLogout (e) {
      Modal.confirm({
        title: this.$t('layouts.usermenu.dialog.title'),
        content: this.$t('layouts.usermenu.dialog.content'),
        onOk: () => {
          // return new Promise((resolve, reject) => {
          //   setTimeout(Math.random() > 0.5 ? resolve : reject, 1500)
          // }).catch(() => console.log('Oops errors!'))
          return this.$store.dispatch('Logout').then(() => {
            if(process.env.VUE_APP_ELECTRON) {
              const { ipcRenderer } = require('electron')
              ipcRenderer.send('force-reload')
            } else {
              this.$router.push({ name: 'login' })
            }
          })
        },
        onCancel () {}
      })
    },
    modifyPwd () {
      this.$router.push({ name: 'modifyPwd' })
    },
    openFeedback () {
      this.feedbackForm = { type: '建议', content: '', contact: '' }
      this.feedbackVisible = true
    },
    handleSubmitFeedback () {
      if (!this.feedbackForm.content || this.feedbackForm.content.trim().length < 10) {
        this.$message.warning('请至少填写10个字的反馈内容')
        return
      }
      this.feedbackSubmitting = true
      setTimeout(() => {
        this.feedbackSubmitting = false
        this.feedbackVisible = false
        this.$message.success('反馈已提交，感谢您的建议！')
      }, 800)
    }
  }
}
</script>

<style lang="less" scoped>
.ant-pro-drop-down {
  :deep(.action) {
    margin-right: 8px;
  }
  :deep(.ant-dropdown-menu-item) {
    min-width: 160px;
  }
}
.item {
  font-size: 14px;
  font-weight: 100;
  color: #979797;
  margin-bottom: 10px;
}
</style>
